export default __webpack_public_path__ + "locales/lo-LA/DeleteProfileEverDialog.json?hash=fc8998970c14bd6c75c59dcfde8f9f28";